import React, { createContext } from "react"
import { useParams } from "react-router"
import { useSearchParams } from "react-router"
import useRawState from "../hooks/useRawState"

const PitchContext = createContext()
export default PitchContext

export function RouteBasedPitchProvider({ children }) {
    const { pitchId } = useParams()

    return (
        <PitchProvider pitchId={pitchId} children={children} />
    )
}

export function QueryBasedPitchProvider({ children }) {
    const [searchParams] = useSearchParams()

    return (
        <PitchProvider pitchId={searchParams.get('pitch')} children={children} />
    )
}

function PitchProvider({ pitchId, ...props }) {
    let pitchResult = {}
    if (pitchId) pitchResult = useRawState(`/api/current/pitches/${pitchId}`)

    return <PitchContext.Provider value={pitchResult} {...props} />
}